<template>
  <v-col>
    <v-btn fab fixed top left color="white" outlined>
      <span class="white--text headline">{{todaysFeedCount}}</span>
    </v-btn>
    <div class="display-1">Last Feed</div>
    <div class="status mt-1 mb-1">
      <breast :side="latestFeed.first" status outlined/>
      <breast v-if="latestFeed.both" :side="latestFeed.first === 'L' ? 'R' : 'L'" status outlined/>
    </div>
    <table class="title mt-1 mb-1">
      <tr>
        <td>Started</td>
        <td>{{ latestFeed.startedAt.toDate() | moment('HH:mm')}}</td>
      </tr>
      <tr>
        <td colspan="2">{{ timeSinceFeed }}</td>
      </tr>
      <tr v-if="latestFeed.next">
        <td>Next</td>
        <td>{{ latestFeed.next | moment('HH:mm')}}</td>
        <td/>
      </tr>
    </table>
    <v-btn v-if="!latestFeed.both" dark large color="orange" @click="both">Both</v-btn>
    <div v-else class="spacer"></div>
  </v-col>
</template>

<script>
import Breast from './Breast';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'LastFeed',
  components: {Breast},
  computed: {
    ...mapGetters('feeds', [
      'latestFeed',
      'timeSinceFeed',
      'todaysFeedCount'
    ])
  },
  methods: {
    ...mapActions('feeds', [
      'setLatestBoth'
    ]),
    both() {
      this.setLatestBoth().catch(err => this.$logger.error(err));
    }
  }
}
</script>

<style scoped>
  .display-1 {
    margin-top: 40px;
  }
  .spacer {
    height: 35px;
  }

  .status {
    text-align: left;
    width: 324px;
    margin: 0 auto;
  }

  table.title {
    text-align: left;
    margin: 0 auto;
  }

  table.title td {
    padding: 10px;
  }

  table.title td:first-child {
    text-align: right;
  }
</style>
